<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="biosecurityIncidentFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                biosecurityIncidentFileForm: () => import('../forms/BiosecurityIncidentFileForm'),
                headers: [
                    { text: 'Biosecurity Incident', value: 'biosecurityIncidentId', table: 'biosecurityIncidents', form: () => import('../forms/BiosecurityIncidentForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    biosecurityIncidents: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "biosecurityIncidentId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'biosecurityIncidentFiles',
                editPageName: 'biosecurityIncidentFile',
                apiMethod: 'BiosecurityIncidentFiles',
                claimName: 'BiosecurityIncidentFiles',
                formTitle: 'Biosecurity Incident File',
                excelTitle: 'Biosecurity Incident Files',
                hasEditPage: false,
            }
        },
    };
</script>
